import {
  updateLabelConfig,
  labelConfigSelector,
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
} from '../../../../data/labelInfos/index.js'
import ConfigSelect from '../ConfigSelect.js'
import {getState, useSelector} from '../../../../store.js'
import {UPS} from '../../../../common/constants/ShipperNames.js'
import {LABEL_PROPERTY_IS_MAIL_INNOVATIONS} from './MailInnovations.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'

const VALID_SHIPPER_TYPES = [UPS]

function uspsEndorsementTemplate(shipperType) {
  return `${shipperType}__usps_endorsement`
}
const VALID_LABEL_PROPERTIES = VALID_SHIPPER_TYPES.map((shipperType) =>
  uspsEndorsementTemplate(shipperType),
)

function labelPropertiesFunc(shipperType, labelInfoID) {
  const {is_mail_innovations} = labelConfigSelector(getState(), {labelInfoID})

  return is_mail_innovations && VALID_SHIPPER_TYPES.includes(shipperType)
    ? [uspsEndorsementTemplate(shipperType)]
    : []
}

const USPS_ENDORSEMENT_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_IS_MAIL_INNOVATIONS,
]

function dependentPropertiesFunc() {
  return USPS_ENDORSEMENT_DEPENDENT_PROPERTIES
}

export default function USPSEndorsement() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = USPSEndorsement.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const {is_mail_innovations: isMailInnovations} = useSelector((state) =>
    labelConfigSelector(state, {labelInfoID}),
  )

  return (
    <ConfigSelect
      label="USPS Endorsement"
      noEmptyOption
      hide={!isMailInnovations}
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="usps_endorsement"
    />
  )
}

USPSEndorsement.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return VALID_LABEL_PROPERTIES
    },
  },
]
